import { getAxiosInstance } from "../../../np-rest/rest";
import restCrudActions from '../../../np-crud/store/restCrudActions'
import config from "../../../../config/config";
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'binary-images',
    pluginName: 'IMPORT_EXPORT',
    entityName: 'BINARY_IMAGE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    editSuccessUseBackendMessage: true
});

const updateDownloadProgress = progress => {

    return {
        type: 'IMPORT_EXPORT|BINARY_IMAGE|DOWNLOAD_PROGRESS',
        downloadProgress: progress.downloadProgress,
        maxSize: progress.maxSize,
        currentSize: progress.currentSize,
        snackBar: progress.snackBar,
        data: progress,
        name: progress.name
    };
};

const listAllBinaryImageTypes = data => {
    return {
        type: 'IMPORT_EXPORT|BINARY_IMAGE_TYPE|LIST',
        binaryImageTypes: data
    };
};
// Create BinaryImage  action creators
export const createBinaryImageInit = () => {
    return crudActions.createInit();
};
export const createBinaryImageStart = () => {
    return crudActions.createStart();
};
export const createBinaryImageSuccess = createdBinaryImage => {
    return crudActions.createSuccess(createdBinaryImage);
};
export const createBinaryImageFail = error => {
    return crudActions.createFail(error);
};

export const createNewBinaryImage = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(uploadProgress({ progress: null, loadSize: null, maxSize: null, snackStart: true }))
        dispatch(createBinaryImageInit());
        try {
            const config1 = {
                onUploadProgress: progressEvent => {
                    dispatch(uploadProgress({ progress: Math.round((progressEvent.loaded * 100) / data.get('File').size), loadSize: Math.round((progressEvent.loaded / 1048576)), maxSize: Math.round((progressEvent.total / 1048576)), snackStart: true }))
                }
            }
            dispatch(createBinaryImageStart());
            let res = await rest.post(`${config.backend_domain}:${config.backend_port}/binary-images/create`, data, config1);
            if (res.status === 200) {
                dispatch(createBinaryImageSuccess());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : 'Create binary image was successful.'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: true }))
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                dispatch(createBinaryImageFail());
                return;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: true }))

            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Cannot create binary image.'}`,
                options: {
                    variant: 'error'
                }
            });
            dispatch(createBinaryImageFail());
            return false;
        }
    }
}

// Fetch securaze action creators
export const fetchBinaryImageInit = () => {
    return crudActions.fetchInit();
};
export const fetchBinaryImageStart = () => {
    return crudActions.fetchStart();
};
export const fetchBinaryImageSuccess = (fetchBinaryImageCount, listBinaryImageCount) => {
    return crudActions.fetchSuccess(fetchBinaryImageCount, listBinaryImageCount);
};
export const fetchBinaryImageFail = () => {
    return crudActions.fetchFail();
};

export const fetchBinaryImageCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchBinaryImageStart());
        try {
            let countRes = await rest.post("binary-images/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchBinaryImageSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchBinaryImageFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch binary images."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchBinaryImageFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch binary images."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};


export const fetchBinaryImage = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchBinaryImageStart());
        try {
            let listRes = await rest.post("binary-images/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchBinaryImageSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchBinaryImageFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchBinaryImageFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch binary images."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: [] };
        }
    }
};

// Load BinaryImage action creators
export const loadBinaryImageInit = () => {
    return crudActions.loadInit();
};
export const loadBinaryImageStart = () => {
    return crudActions.loadStart();
};
export const loadBinaryImageSuccess = loadedBinaryImage => {
    return crudActions.loadSuccess(loadedBinaryImage);
};
export const loadBinaryImageFail = error => {
    return crudActions.loadFail(error);
};
export const loadBinaryImage = (id, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, id, options);
    };
};

// Bulk delete binary images
export const bulkDeleteBinaryImageInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteBinaryImageStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteBinaryImageSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteBinaryImageFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteBinaryImage = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteBinaryImageStart());
        try {
            let res = await rest.post('/binary-images/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteBinaryImageSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted binary images.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteBinaryImageFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete binary images."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete binary images."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteBinaryImageFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const uploadProgress = (data) => {
    return {
        type: 'SOFTWARE|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart
    };
};

// custom functions
export const listBinaryImageTypes = (activeCustomerID, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/binary-image-types/list', { listAll: true, ActiveCustomerID: activeCustomerID }, options);
            if (res.data && res.data.succeeded) {
                const binaryImageTypes = [];
                for (var binaryImageType of res.data.result.data) {
                    binaryImageTypes.push({ value: binaryImageType.BinaryImageTypeID, displayValue: `${binaryImageType.Name} (${binaryImageType.Key})` });
                }
                dispatch(listAllBinaryImageTypes(binaryImageTypes));
                return binaryImageTypes;
            }
            else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }

        } catch (error) {
            return [];
        }
    };
}

// Edit BinaryImage  action creators
export const editBinaryImageInit = () => {
    return crudActions.editInit();
};
export const editBinaryImageStart = () => {
    return crudActions.editStart();
};
export const editBinaryImageSuccess = editedBinaryImage => {
    return crudActions.editSuccess(editedBinaryImage);
};
export const editBinaryImageFail = error => {
    return crudActions.editFail(error);
};
export const editBinaryImage = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editBinaryImageStart());
        try {
            let res = await rest.post('/binary-images/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editBinaryImageSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated binary image.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editBinaryImageFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit binary image."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit binary image."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editBinaryImageFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Custom functions 
export const downloadFile = (ImageID, customerID, name) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        return fetch(`${config.backend_domain}:${config.backend_port}/binary-images/download?BinaryImageID=${ImageID}&ActiveCustomerID=${customerID.ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            try {
                if (response.status === 200) {
                    const reader = response.body.getReader();
                    const contentLength = +response.headers.get('fileSize');
                    let receivedLength = 0;
                    let chunks = [];
                    let percentage = 0;
                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) {
                            dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false }));

                            break;
                        }
                        chunks.push(value);

                        receivedLength += value.length;
                        if (percentage + 1 === Math.floor(receivedLength / contentLength * 100)) {
                            percentage += 1;
                            dispatch(updateDownloadProgress({ downloadProgress: Math.floor(receivedLength / contentLength * 100), maxSize: Math.floor(contentLength / 1048576), currentSize: Math.floor(receivedLength / 1048576), snackBar: true, name: name, ImageID: ImageID }));
                        }
                    }
                    return new Blob(chunks);
                }
                else {
                    snackActions.snackBar({
                        message: `Download failed`,
                        options: {
                            variant: 'warning'
                        }
                    })

                    return null;
                }
            } catch (error) {
                dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name, ImageID: ImageID }));
                snackActions.snackBar({
                    message: `${error && error.message ? error.message : 'Download failed'}`,
                    options: {
                        variant: 'error'
                    }
                });
            }
        });
    }
}
// Custom functions 
export const downloadFileTool = (ToolID, id, name) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        return fetch(`${config.backend_domain}:${config.backend_port}/securaze-tools/download?SecurazeToolID=${ToolID}&ActiveCustomerID=${id}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            try {

                if (response.status === 200) {
                    const reader = response.body.getReader();

                    const contentLength = +response.headers.get('fileSize');
                    let receivedLength = 0;
                    let chunks = [];
                    while (true) {
                        const { done, value } = await reader.read();

                        if (done) {
                            break;
                        }
                        chunks.push(value);
                        receivedLength += value.length;

                        dispatch(updateDownloadProgress({ downloadProgress: Math.floor(receivedLength / contentLength * 100), maxSize: Math.floor(contentLength / 1048576), currentSize: Math.floor(receivedLength / 1048576), snackBar: true, name: name, ImageID: ToolID }));

                    }
                    return new Blob(chunks);
                }
                return null;

            } catch (error) {
                dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name, ImageID: ToolID }));
                snackActions.snackBar({
                    message: `${error && error.message ? error.message : 'Download failed'}`,
                    options: {
                        variant: 'error'
                    }
                });
            }
        });
    }
}

export const sendPBillingPlansStart = () => {
    return {
        type: 'SOFTWARE|RECOVER_BILLING_START',
        loading: true
    };
};
export const sendPBillingPlansSuccess = () => {
    return {
        type: 'SOFTWARE|RECOVER_BILLING_SUCCESS',
        loading: false,
    };
};
export const sendPBillingPlansFail = () => {
    return {
        type: 'SOFTWARE|RECOVER_BILLING_FAIL',
        loading: false
    };
};

export const sendReleaseNotes = (id) => {
    const rest = getAxiosInstance();
    let token = localStorage.getItem('SESSION');

    id['Token'] = token
    return async dispatch => {
        try {
            dispatch(sendPBillingPlansStart())

            let res = await rest.post(`/binary-images/send-release-notes`, id);
            if (res.data.status === 200) {
                dispatch(sendPBillingPlansSuccess())

                snackActions.snackBar({
                    message: `${res && res.data && res.data.message ? res.data.message : 'Success'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.status === 200;

            }
            else {
                dispatch(sendPBillingPlansFail())

                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            dispatch(sendPBillingPlansFail())

            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Send failed'}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const ClearState = (data) => {
    return ({
        type: 'CLEAR_STATE',
    });
}
export const ClearStateCreate = (data) => {
    return ({
        type: 'CLEAR_STATE_CREATE',
    });
}